import React, { useState } from "react";
import { Button } from "expano-components";
import { AsyncSelect, Modal } from "components";
import { client_v2, getApiErrorMessage } from "utils/api";
import getPackers from "utils/queries/getPackers";
import { toastr } from "react-redux-toastr";

import { ReactComponent as PacksIcon } from "icons/packs.svg";

const CART_BOX_LABELS = {
  none: "none (wózek box_1)",
  box_4: "box_4",
  box_6: "box_6",
  box_12: "box_12",
  box_24: "box_24",
  heavy: "heavy (wózek)",
};

const CreateFastShipmentModal = ({
  handleClose,
  onCreated,
  cart_box_size,
  dispatch_due_today = false,
  gdn_id,
  expano_oms_id,
}) => {
  const [picker_id, setPickerId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!picker_id) {
      toastr.error("Błąd", "Wybierz pikera");
      return;
    }
    setSubmitting(true);
    try {
      const body = {
        picker_id,
        cart_box_size,
        dispatch_due_today,
      };
      if (gdn_id != null) body.gdn_id = gdn_id;
      await client_v2.post("/gdn_packs/compose_fast_shipment", body);
      toastr.success("Utworzono", "Pak szybkiej wysyłki został utworzony");
      onCreated();
      handleClose();
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    } finally {
      setSubmitting(false);
    }
  };

  const cart_label =
    (cart_box_size && CART_BOX_LABELS[cart_box_size]) || cart_box_size || "";
  const scope_suffix = dispatch_due_today ? ", tylko na dziś" : "";
  const order_suffix =
    gdn_id != null && expano_oms_id != null
      ? ` — zam. OMS ${expano_oms_id} (WMS #${gdn_id})`
      : "";
  const modal_title = cart_label
    ? `Utwórz paka — szybka wysyłka (${cart_label}${scope_suffix})${order_suffix}`
    : `Utwórz paka — szybka wysyłka${scope_suffix}${order_suffix}`;

  return (
    <Modal
      handleClose={handleClose}
      header={{ title: modal_title, icon: <PacksIcon /> }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <button
            type="button"
            className="btn btn-sm btn-green"
            disabled={!picker_id || submitting}
            onClick={handleSubmit}
          >
            <span>Utwórz</span>
          </button>
        </>
      }
    >
      <AsyncSelect
        label="Picker"
        getData={(q) => getPackers(q)}
        onChange={({ value }) => setPickerId(value)}
      />
    </Modal>
  );
};

export default CreateFastShipmentModal;
